import { useEffect, useRef, useState } from "react";

function useDummyScrollbar() {
	const containerRef = useRef<HTMLDivElement>(null);
	const [node, setNode] = useState<HTMLDivElement>();
	const [containerWidth, setContainerWidth] = useState(0);
	const [innerWidth, setInnerWidth] = useState(0);
	const intervalRef = useRef<NodeJS.Timer>();
	const isSyncing = useRef(false);
	const scrollerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const nodeRef = scrollerRef.current;
		if (nodeRef) {
			setNode(nodeRef);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [scrollerRef.current]);

	useEffect(() => {
		const onTableScroll = (event: Event) => {
			if (isSyncing.current) return;
			const target = event.currentTarget as HTMLDivElement;
			if (!containerRef.current || containerRef.current.scrollLeft === target.scrollLeft) return;
			isSyncing.current = true;
			containerRef.current.scrollLeft = target.scrollLeft;
			isSyncing.current = false;
		};

		const onDummyScroll = (event: Event) => {
			if (isSyncing.current) return;
			const target = event.currentTarget as HTMLDivElement;
			if (!node || node.scrollLeft === target.scrollLeft) return;
			isSyncing.current = true;
			node.scrollLeft = target.scrollLeft;
			isSyncing.current = false;
		};

		const onInterval = () => {
			if (!node) {
				return;
			}
			setContainerWidth(node.clientWidth);
			setInnerWidth(node.scrollWidth);
		};

		const currentContainerRef = containerRef.current;

		if (node) {
			intervalRef.current = setInterval(onInterval, 1000);

			node.addEventListener("scroll", onTableScroll);
			if (currentContainerRef) currentContainerRef.addEventListener("scroll", onDummyScroll);
		}

		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);

			if (node) node.removeEventListener("scroll", onTableScroll);

			if (currentContainerRef) currentContainerRef.removeEventListener("scroll", onDummyScroll);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [node]);

	return {
		component: (
			<div
				ref={containerRef}
				className="dummy-scrollbar-container"
				style={{
					width: containerWidth + "px",
				}}
			>
				<div className="dummy-scrollbar-inner" style={{ width: innerWidth + "px" }} />
			</div>
		),
		scrollerRef,
	};
}

export { useDummyScrollbar };
